<script setup lang="ts">
import { useUploadCv } from '../../model/cv-or-resume/upload-cv.hooks'
import DropzoneContainer from '../upload/DropzoneContainer.vue'

defineOptions({
  name: 'UploadCv',
})

const {
  mode,
  cv,
  setDroppedCv,
} = useUploadCv()

const dropzoneRef = useTemplateRef<InstanceType<typeof DropzoneContainer>>('dropzoneRef')

const resetFiles = (): void => {
  dropzoneRef.value?.resetFiles()
}

defineExpose({
  resetFiles,
})

</script>

<template>
  <div class="upload-cv">
    <DropzoneContainer
      ref="dropzoneRef"
      :mode="mode"
      :value="cv"
      @click:drop="(acceptFiles) => setDroppedCv(acceptFiles)"
    />
  </div>
</template>

